// table.component.ts
import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    standalone: false
})
export class TableComponent implements OnInit {
  @Input() ebitPerShareArray: any[] = [];
  @Input() epsArray: any[] = [];
  @Input() dividentPerShareArray: any[] = [];
  @Input() revenuePerShare: any[] = [];
  @Input() bookValuePerShare: any[] = [];
  @Input() tangibleBookValuePerShare: any[] = [];
  @Input() epsFwd: any[] = [];
  @Input() price_to_earning: any[] = [];

  @Output() noDataEvent = new EventEmitter<boolean>();
  noData: boolean = true; // Initialize as true by default
  years = [2020, 2021, 2022, 2023, 2024];

  constructor() { }

  ngOnInit(): void {
    this.checkNoData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.checkNoData();
  }

  private checkNoData(): void {
    const arrays = [
      this.ebitPerShareArray,
      this.epsArray,
      this.dividentPerShareArray,
      this.revenuePerShare,
      this.bookValuePerShare,
      this.tangibleBookValuePerShare,
      this.epsFwd,
      this.price_to_earning
    ];

    // Check if any array has valid data
    const hasData = arrays.some(array => !this.isArrayAllNull(array));
    this.noData = !hasData;

    // Emit the noData status to parent component
    this.noDataEvent.emit(this.noData); // <-- Add this line
  }

  private isArrayAllNull(array: any[]): boolean {
    if (!array || array.length === 0) return true;
    return array.every(value => value === null || value === undefined);
  }

  roundToTwoDecimals(value: number | null): number | null {
    if (value === null || value === undefined) return null;
    return parseFloat(value.toFixed(2));
  }

  roundToTwoDecimals2(value: number): number | string {
    if (value === null || value === undefined) return '-';
    return Math.abs(parseFloat(value.toFixed(2)));
  }

  hasNonNullValue(array: (number | null)[]): boolean {
    return array && array.length > 0 && array.some(value => value !== null && value !== undefined);
  }
}
